<br />
<div *ngIf="toggle">
  <div class="form-row">
    <div class="form-group col-md-24">
      <h1 for="inventors">Verilere Başvuru Sahibi Kaydı Ekle</h1>

      <br />
      <div class="form-group col-md-8" id="inventors">
        <div class="form-group col-md-3" >
          <div>
            <input [(ngModel)]="companyName" placeholder="Başvuru Sahibin Adı"
            (ngModelChange)="companyName = $event.toLowerCase()"
            />
          </div>
        </div>

        <div class="form-group col-md-3" >
          <div >
            <input
            [(ngModel)]="companyAdress"
            (ngModelChange)="companyAdress= $event.toLowerCase()"
              placeholder="Başvuru Sahibi Adresi"
            />
          </div>
        </div>

        <div class="form-group col-md-3" >
          <div >
            <input
            [(ngModel)]="companyIdentityNo"
            (ngModelChange)="companyIdentityNo = $event.toLowerCase()"
              placeholder="Başvuru Sahibi Kurum No."
            />
          </div>
        </div>
        <div id="inventors">
          <div>
            <button
              (click)="submit()"
              class="btn"

              style="
                margin-left: auto;
                margin-right: 20%;
                font-size: 18px;
                display: block;
                height: fit-content;
              "
            >
              Başvuru Sahibi Bilgilerini Kaydet
            </button>
          </div>
        </div>
      </div>


    </div>
  </div>
</div>

<h2 *ngIf="!error">{{ record }}</h2>
<h2 *ngIf="error">
  {{ error }} . Lütfen kayıt bilgilerinizi ve internetinizi kontrol ediniz.
</h2>
<br />

<button
  type="button"
  class="btn btn-warning"
  style="background-color: #d70040"
  (click)="findCompany()"
>
  {{
    visible
      ? "Kayıtlı Başvuru Sahiplerini Gizle"
      : "Kayıtlı Başvuru Sahiplerini Listele"
  }}
</button>

<h2 style="margin-left: 2%" *ngIf="visible && !error">
  Kayıtlı Başvuru Sahipleri
</h2>
<h2 *ngIf="error">
  {{ error }} . Lütfen kayıt bilgilerinizi ve internetinizi kontrol ediniz.
</h2>
<input
  *ngIf="visible && !error"
  class="form-control"
  type="text"
  name="search"
  class="icon"
  [(ngModel)]="searchText"
  (ngModelChange)="searchText = $event.toLowerCase()"
  autocomplete="off"
  placeholder="Başvuru Sahibi Bilgileri Üzerinden Arama Yap"
  id="input1"
/>

<table *ngIf="visible && !error">
  <thead>
    <th>#</th>
    <th>Başvuru Sahibi Adı</th>
    <th>Başvuru Sahibi Adresi</th>
    <th>Başvuru Sahibi Kurum No.</th>
    <th>Kaydı oluşturan ve kayıt tarihi</th>
  </thead>
  <tbody>
    <tr *ngFor="let user of users; let i = index">
      <ng-container *ngFor="let item of user | filter: searchText">
        <td>{{ i + 1 }}</td>
        <td>{{ item.CompanyName }}</td>
        <td>{{ item.CompanyAdress }}</td>
        <td>{{ item.CompanyIdentityNo }}</td>

        <td>
          Kaydı Yapan:{{ item.LoggedUser[0].recordingUser }}
          <p>Kayıt Tarihi:{{ item.LoggedUser[0].date | date: "dd/MM/yyyy" }}</p>
        </td>
        <td style="background-color: #f8f9fb">
          <button
            type="button"
            id="add"
            class="btn btn-primary"
            style="background-color: #d70040"
            (click)="removeCompany(i)"
          >
            Başvuru Sahibi kaydını sil
          </button>
        </td>
      </ng-container>
    </tr>
  </tbody>
</table>
